import type { PostHog } from "posthog-js";

export function usePosthog() {
  const { $posthog } = useNuxtApp();

  return $posthog as PostHog | undefined;
}
